export default "__VITE_ASSET__BzkLF0Z3__"